// extracted by mini-css-extract-plugin
export default {"outer_list":"FrontPageQuestionSelectorText_outer_list__1evz1","inner_list":"FrontPageQuestionSelectorText_inner_list__OXXN5"};